import { ReactComponent as DisabledIcon } from '@elementary/common-ui/assets/16x16/disabled.svg';
import { ReactComponent as Logo } from '@elementary/common-ui/assets/logo.svg';
import { ReactComponent as DeleteConnection } from '@elementary/common-ui/assets/minus-x-minus.svg';
import { Dialog, FlexCenter } from '@elementary/common-ui/components';
import { FetchDataStoresApi } from 'shared/types';
import styled from 'styled-components';
import { Typography } from '@mui/material';
import { getMetastoreIcon } from './metastoreIcons';

const IconsWrapper = styled(FlexCenter)`
  gap: 8px;
  height: 100%;
`;

const LogoWrapper = styled(FlexCenter)`
  width: 72px;
  height: 72px;
  border-radius: 12px;
  padding: 16px;
  background: ${({ theme }) => theme.palette.common.magenta};
`;

const PlatformIconWrapper = styled(FlexCenter)`
  width: 72px;
  height: 72px;
  border-radius: 12px;
  padding: 16px;
  border: 2px solid ${({ theme }) => theme.palette.common.gray5};
  box-sizing: border-box;
`;

type Props = {
  open: boolean;
  onClose: () => void;
  onSubmit: (id: string) => void;
  loading?: boolean;
  selectedIntegration?: FetchDataStoresApi['integrations'][0];
};

function DeleteDataCatalogDialog({
  open,
  onClose,
  selectedIntegration,
  onSubmit,
  loading,
}: Props) {
  const catalogType = selectedIntegration?.config.catalog_type;
  const icon = catalogType ? getMetastoreIcon(catalogType, 40) : null;

  return (
    <Dialog
      open={open}
      graphic={
        <IconsWrapper>
          <LogoWrapper>
            <Logo />
          </LogoWrapper>
          <DeleteConnection />
          <PlatformIconWrapper>{icon}</PlatformIconWrapper>
        </IconsWrapper>
      }
      titleIcon={<DisabledIcon />}
      title="Delete connection"
      message={
        <Typography>
          Are you sure you want to delete your{' '}
          <Typography component="span" sx={{ fontWeight: 'bold' }}>
            {selectedIntegration?.name}
          </Typography>{' '}
          connection?
        </Typography>
      }
      secondaryMessage="This action is irreversible."
      onClose={onClose}
      onConfirmButtonClick={() =>
        selectedIntegration && onSubmit(selectedIntegration.id)
      }
      isLoading={!!loading}
      confirmText={loading ? 'Deleting' : 'Delete connection'}
      variant="error"
    />
  );
}

export default DeleteDataCatalogDialog;
